import { FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const useFormFieldValidation = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  required?: boolean,
  customRules?: RegisterOptions<TFieldValues, TName>,
) => {
  const { t } = useTranslation();
  const requiredRule = required ? { required: t('validation.required') } : {};

  return { ...customRules, ...requiredRule };
};
